<template>
  <div>
    <el-card :body-style="{ height: '100%' }" class="h-full">
      <div class="flex flex-wrap">
        <el-input
          clearable
          v-model="search.keywords"
          class="w-200px mr-10px mb-10px"
          size="small"
          :maxlength="50"
          :placeholder="`${$t('单位名称、单位负责人')}`"
        ></el-input>
        <el-select
          size="small"
          v-model="search.status"
          :placeholder="`${$t('单位状态')}`"
          filterable
          clearable
          class="w-200px mr-10px mb-10px"
        >
          <el-option
            v-for="item in unitStatusList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          v-model="search.isBlacklist"
          :placeholder="`${$t('是否黑名单')}`"
          filterable
          clearable
          class="w-200px mr-10px mb-10px"
        >
          <el-option
            v-for="item in blackList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-button @click="searchList" size="small" type="primary">搜索</el-button>
        <el-button @click="reset" size="small">重置</el-button>
        <el-button
          @click="operate('create', null)"
          size="small"
          type="primary"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button @click="setBlack(true)" size="small" :disabled="!$hasAccess('addBlack')"
          >加入黑名单</el-button
        >
        <el-button @click="setBlack(false)" size="small" :disabled="!$hasAccess('removeBlack')"
          >移除黑名单</el-button
        >
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        height="calc(100% - 104px)"
        class="mt-10px"
        row-key="id"
        ref="table"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="50" reserve-selection></el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          :label="`${$t('单位名称')}`"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="projectNames"
          show-overflow-tooltip
          :label="`${$t('所属项目')}`"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="leaderName"
          show-overflow-tooltip
          width="120"
          :label="`${$t('单位负责人')}`"
        ></el-table-column>
        <el-table-column
          prop="phoneNumber"
          show-overflow-tooltip
          :label="`${$t('联系电话')}`"
          width="140"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('在厂周期')}`"
          width="190"
          prop="inFactoryCycle"
        >
        </el-table-column>
        <el-table-column prop="status" width="80" :label="`${$t('单位状态')}`">
          <template slot-scope="scope">
            <el-tag size="mini" :type="unitStatusTypes(scope.row.status)">{{
              scope.row.statusStr
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('单位总人数')}`"
          width="100"
          prop="inToFactoryCount"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="`${$t('已完成入厂人数')}`"
          width="120"
          prop="personnelCount"
        >
        </el-table-column>
        <el-table-column prop="isBlacklist" width="100" :label="`${$t('是否黑名单')}`">
          <template slot-scope="scope">
            <el-tag size="mini" type="danger" v-if="scope.row.isBlacklist === true">是</el-tag>
            <el-tag size="mini" type="success" v-else-if="scope.row.isBlacklist === false"
              >否</el-tag
            >
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="approvalStatus" width="80" :label="`${$t('流程状态')}`">
          <template slot-scope="scope">
            <el-tag size="mini" :type="workFlowStatusTypes(scope.row.approvalStatus)">{{
              scope.row.approvalStatusStr
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="270px" fixed="right">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px text-right"
        background
        :current-page.sync="page.pageNo"
        @size-change="searchList"
        @current-change="findList"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <ApprovalFlowDialog
      :visible.sync="approvalFlowDialog"
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>
    <ShortTermContractorDialog
      :visible.sync="shortTermContractorDialog"
      :id="rowId"
      :mode="dialogMode"
      @save="searchList"
    />
    <el-dialog
      :close-on-click-modal="false"
      title="加入黑名单"
      :visible.sync="dialogBlackShow"
      class="mini-dialog"
      v-dialogDrag
    >
      <el-form ref="formBlack" label-width="150px" :rules="rulesForm" :model="form">
        <el-form-item label="评价等级" prop="evaluationlevel">
          <el-rate class="!leading-loose" v-model="form.evaluationlevel" show-text> </el-rate>
        </el-form-item>
        <el-form-item label="评价意见" prop="evaluationOpinions">
          <el-input
            v-model="form.evaluationOpinions"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
            placeholder="请填写评价意见"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="saveBlackList" :loading="saveLoading"
          >确定</el-button
        >
        <el-button size="small" @click="dialogBlackShow = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="延期"
      :visible.sync="delayDialogVisible"
      class="small-dialog"
      v-dialogDrag
      :before-close="closeDelayDialog"
    >
      <el-form ref="delayForm" label-width="150px" :model="delayForm" :rules="delayRules">
        <el-form-item label="单位名称">
          <el-input v-model="delayForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="延期时间" prop="delayDate">
          <el-date-picker
            size="small"
            v-model="delayForm.delayDate"
            type="date"
            :placeholder="`${$t('请选择')}`"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="延期原因" prop="reason">
          <el-input
            v-model="delayForm.reason"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
            placeholder="请输入延期原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="saveDelay('save')" :loading="delayLoading"
          >确定</el-button
        >
        <el-button size="small" type="primary" @click="saveDelay('submit')">提交</el-button>
        <el-button size="small" @click="closeDelayDialog(null)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { PeriodContractorApi } from '@wiz-api/contractor-management'
import { unitStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import { map, filter } from 'lodash'
import dayjs from 'dayjs'

const TableOperateButton = () => {
  return import('@/components/safety/TableOperateButton/TableOperateButton')
}
const ApprovalFlowDialog = () => {
  return import('@/components/safety/ApprovalFlow/ApprovalFlowDialog')
}
const ShortTermContractorDialog = () => {
  return import('../components/ShortTermContractorDialog')
}
const periodContractorApi = new PeriodContractorApi()
export default {
  components: {
    TableOperateButton,
    ApprovalFlowDialog,
    ShortTermContractorDialog,
  },
  data() {
    const validateDelayDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择延期时间'))
      } else if (dayjs(this.delayForm.lastEndDate).valueOf() >= dayjs(value).valueOf()) {
        callback(new Error('延期时间必须大于当前在厂周期结束时间'))
      } else {
        callback()
      }
    }
    return {
      unitStatusList: [
        { code: 0, displayName: '待入厂' },
        { code: 1, displayName: '在厂' },
        { code: 2, displayName: '已退场' },
      ],
      workFlowStatusList: [
        { code: 0, displayName: '待提交' },
        { code: 1, displayName: '审核中' },
        { code: 2, displayName: '已驳回' },
        { code: 3, displayName: '已撤回' },
        { code: 9, displayName: '已完成' },
      ],
      blackList: [
        { code: true, displayName: '是' },
        { code: false, displayName: '否' },
      ],
      search: {
        status: '',
        keywords: '',
        isBlacklist: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      loading: false,
      tableData: [],
      approvalFlowDialog: false,
      flowTaskId: null,
      shortTermContractorDialog: false,
      rowId: '',
      dialogMode: '',
      dialogBlackShow: false,
      form: {
        evaluationOpinions: '',
      },
      rulesForm: {
        evaluationlevel: [
          { required: true, message: '请选择评价等级', trigger: ['blur', 'change'] },
        ],
      },
      selectionData: [],
      delayDialogVisible: false,
      delayForm: {
        name: '',
      },
      delayRules: {
        delayDate: [
          {
            required: true,
            validator: validateDelayDate,
            trigger: ['change'],
          },
        ],
        reason: [{ required: true, message: '请输入延期原因', trigger: ['blur'] }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        },
      },
      saveLoading: false,
      delayLoading: false,
    }
  },
  computed: {
    unitStatusTypes() {
      return (val) => {
        return unitStatusTypes(val)
      }
    },
    workFlowStatusTypes() {
      return (val) => {
        let type = ''
        switch (val) {
          case 0:
            type = 'primary'
            break
          case 1:
            type = 'warning'
            break
          case 9:
            type = 'success'
            break
          default:
            type = 'danger'
            break
        }
        return type
      }
    },
    unitStatusMap() {
      return (val) => {
        return (
          this.unitStatusList.find((i) => {
            return Number(i.code) === val
          })?.displayName || ''
        )
      }
    },
    currentUser() {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      return userInfo?.profile || {}
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.operate('read', val)
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.operate('update', val)
            },
            isShow: this.$hasAccess('update') && !val.isBlacklist && val.approvalStatus !== 1,
          },
          {
            text: '删除',
            click: () => {
              return this.deleteData(val)
            },
            // 不是单位负责人且流程状态不为审核中,单位状态为待入厂或者已退场
            isShow:
              this.$hasAccess('delete') &&
              this.currentUser.name !== val.account &&
              [0, 2].includes(val.status) &&
              ![1].includes(val.approvalStatus),
          },
          {
            text: '提交',
            click: () => {
              return this.operate('submit', val)
            },
            // 待提交、被驳回（只有提交人能再次提交）、已撤回状态和非黑名单下能提交
            isShow:
              this.$hasAccess('submit') &&
              ([0, 3].includes(val.approvalStatus) ||
                ([2].includes(val.approvalStatus) && val.taskId)) &&
              !val.isBlacklist,
          },
          {
            text: '审批',
            click: () => {
              return this.operate('approve', val)
            },
            // 是下一审批人且流程状态为审核中
            isShow:
              this.$hasAccess('audit') &&
              val.oprateCode === '001' &&
              [1].includes(val.approvalStatus),
          },
          {
            text: '撤回',
            click: () => {
              return this.operate('withdraw', val)
            },
            // 流程状态为审核中
            isShow:
              (this.$hasAccess('withdraw') || this.currentUser.id === val.submitUserId) &&
              [1].includes(val.approvalStatus) &&
              !val.isBlacklist &&
              val.activeRevocation === 1,
          },
          {
            text: '查看流程',
            click: () => {
              return this.handleFlow(val)
            },
            isShow: this.$hasAccess('readFlow') && val.flowTaskId,
          },
          {
            text: '延期',
            click: () => {
              return this.operate('delay', val)
            },
            // 单位状态为在厂或已退场且流程状态为已完成且非黑名单
            isShow:
              this.$hasAccess('delay') &&
              [1, 2].includes(val.status) &&
              !val.isBlacklist &&
              ![1].includes(val.approvalStatus),
          },
        ]
      }
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.$refs.table && this.$refs.table.clearSelection()
      this.selectionData = []
      this.loading = true
      const [err, res] = await periodContractorApi.pagedListQuery({
        ...this.search,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      if (!err) {
        this.tableData = map(res.items, (item) => {
          item.inFactoryCycle = `${dayjs(item.startDate).format('YYYY-MM-DD')}-${dayjs(
            item.endDate
          ).format('YYYY-MM-DD')}`
          return item
        })
        this.total = res.totalCount
      }
      this.loading = false
    },
    reset() {
      this.search = this.$options.data().search
      this.searchList()
    },
    operate(type, row) {
      switch (type) {
        case 'create':
          this.shortTermContractorDialog = true
          this.dialogMode = 'create'
          break
        case 'update':
        case 'approve':
        case 'read':
          if ([0, 2, 3].includes(row.approvalStatus)) {
            this.shortTermContractorDialog = true
            this.dialogMode = type
            this.rowId = row.id
          } else {
            this.$router.push({
              path: `${this.basePath}/contractor-management-sm/short-term-contractor-detail`,
              query: {
                id: row.id,
                mode: type,
              },
            })
          }
          break
        case 'submit':
          this.$confirm('是否确认提交当前记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.loading = true
              let err
              // 驳回调审批接口
              if (row.approvalStatus === 2) {
                ;[err] = await periodContractorApi[row.isDelay ? 'delayApprove' : 'approve']({
                  body: {
                    id: row.id,
                    isPass: true,
                    approve: '',
                    taskId: row.taskId,
                  },
                })
              } else if (!row.isDelay) {
                ;[err] = await periodContractorApi.submit_0(row.id)
              } else {
                ;[err] = await periodContractorApi.delaySave({
                  body: {
                    id: row.id,
                    delayTime: dayjs(row.delayTime).format('YYYY-MM-DD HH:mm:ss'),
                    delayReason: row.delayReason,
                    isSubmit: true,
                  },
                })
              }
              if (!err) {
                this.$message.success('提交成功！')
                this.findList()
              } else {
                this.loading = false
              }
            })
            .catch(() => {})
          break
        case 'delay':
          this.delayDialogVisible = true
          this.delayForm.name = row.name
          this.delayForm.id = row.id
          this.delayForm.approvalStatus = row.approvalStatus
          this.delayForm.taskId = row.taskId
          this.delayForm.lastEndDate = dayjs(row.endDate).format('YYYY-MM-DD')
          break
        case 'withdraw':
          this.$confirm('是否确认撤回当前记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.loading = true
              const [err] = await periodContractorApi[row.isDelay ? 'delayApprove' : 'approve']({
                body: {
                  id: row.id,
                  isPass: true,
                  approve: '',
                  taskId: row.flowTaskId,
                  isRevocation: true,
                },
              })
              if (!err) {
                this.$message.success('撤回成功！')
                this.findList()
              } else {
                this.loading = false
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    // 查看流程
    handleFlow(row) {
      this.flowTaskId = row.flowTaskId
      if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    deleteData(row) {
      this.$confirm('是否确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await periodContractorApi.callDelete(row.id)
          if (!err) {
            this.$message.success('删除成功！')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    selectionChange(values) {
      this.selectionData = values
    },
    setBlack(isBlack) {
      if (this.selectionData?.length === 0) {
        this.$message.warning('请选择记录')
        return
      }
      if (isBlack) {
        const filterData = filter(this.selectionData, (item) => {
          return item.isBlacklist
        })
        if (filterData.length > 0) {
          this.$message.warning('请选择非黑名单记录')
          return
        }
        // 加入黑名单
        this.dialogBlackShow = true
        this.$nextTick(() => {
          this.$refs.formBlack.resetFields()
        })
      } else {
        const filterData = filter(this.selectionData, (item) => {
          return !item.isBlacklist
        })
        if (filterData.length > 0) {
          this.$message.warning('请选择黑名单记录')
          return
        }
        this.$confirm('确认移除黑名单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err] = await periodContractorApi.moveOutBlacklist({
              body: map(this.selectionData, 'id'),
            })
            if (!err) {
              this.$message.success('移除黑名单成功！')
              this.findList()
            }
          })
          .catch(() => {})
      }
    },
    saveBlackList() {
      this.$refs.formBlack.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const [err] = await periodContractorApi.moveToBlacklist({
            body: map(this.selectionData, (item) => {
              return {
                id: item.id,
                appraiseGrade: this.form.evaluationlevel,
                appraiseOpinion: this.form.evaluationOpinions,
              }
            }),
          })
          this.saveLoading = false
          if (!err) {
            this.$message.success('设置黑名单成功！')
            this.dialogBlackShow = false
            this.findList()
          }
        }
      })
    },
    saveDelay(type) {
      this.$refs.delayForm.validate(async (valid) => {
        if (valid) {
          this.delayLoading = true
          let apiRes = []
          if (this.delayForm.approvalStatus === 2) {
            apiRes = await periodContractorApi.delayApprove({
              body: {
                id: this.delayForm.id,
                isPass: true,
                approve: '',
                taskId: this.delayForm.taskId,
              },
            })
          } else {
            apiRes = await periodContractorApi.delaySave({
              body: {
                id: this.delayForm.id,
                delayTime: dayjs(this.delayForm.delayDate).format('YYYY-MM-DD 23:59:59'),
                delayReason: this.delayForm.reason,
                isSubmit: type === 'submit',
              },
            })
          }
          this.delayLoading = false
          if (!apiRes[0]) {
            this.$message.success(`${type === 'save' ? '保存' : '提交'}成功！`)
            this.closeDelayDialog()
            this.findList()
          }
        }
      })
    },
    closeDelayDialog(done) {
      this.delayForm = this.$options.data().delayForm
      this.$refs.delayForm.clearValidate()
      if (done) {
        done()
      } else {
        this.delayDialogVisible = false
      }
    },
  },
  async created() {
    await this.searchList()
  },
}
</script>

<style></style>
